<!-- eslint-disable max-len -->
<template>
  <div
    id="ticket-detail-view"
    class="my-4 mx-md-5 mx-lg-10 mx-xl-10 pa-2 pt-md-0 px-md-4 mt-md-0 mt-4 maxw-1750 pb-5"
    :style="{paddingTop: '1rem !important'}"
  >
    <!-- ICONS TITLE -->
    <div class="d-flex justify-space-between align-center w-100">
      <!-- VOLVER ATRAS -->
      <div>
        <v-btn
          v-if="!sandetel"
          class="back"
          dark
          icon
          @click="historyBack"
        >
          <v-icon
            :style="{ color: '#27846d', fontSize: '34px' }"
          >
            icon-ayudadigital-volver
          </v-icon>
        </v-btn>
      </div>

      <!-- SEGUIR - COMPARTIR -->
      <div class="d-flex align-center ga-2" v-if="!$vuetify.breakpoint.mdAndUp && !loadingSuscriptor">
        <div
          v-for="(action, i) in ticketActions"
          :key="i"
          class="d-flex align-center"
        >
          <v-btn
            v-if="action.name === 'follow' || action.name === 'follownot' || action.name === 'share'"
            class="back"
            dark
            icon
            @click.stop="openFabsButton(action)"
          >
            <v-icon
              :style="{ color: '#27846d', fontSize: '28px' }"
            >{{ action.name === 'follow' ? 'icon-ayudadigital-ojo-negativo' :  action.icon}}</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <!-- ICONS TITLE -->

    <!-- PAGINACION -->
    <list-navigator-pulso
      v-bind:style="{zIndex: $vuetify.breakpoint.mdAndUp ? 'initial': '10'}"
      v-if="sandetel && listProac.length > 0"
      :backButtonHref="listViewQuery"
      :total="listProac.length"
      :current="listProac.indexOf(idTicket)"
      @navigate="(idx) => viewItemDetails(idx)"
    />
    <!-- PAGINACION -->

    <!-- HEADER -->
    <template  v-if="dataDetails != null && !loadingSuscriptor">
      <!-- TITULO -->
      <div
        :class="[
          'section-mh d-flex flex-nowrap justify-start',
          $vuetify.breakpoint.mdAndUp ? 'flex-row align-center' : 'flex-column align-start',
        ]"
        style="max-width: 100%"
      >
      <h2
          id="title"
          class="title__details--tic disflex"
        >
          <span class="container__chip__tic">
            <span class="tic__priority" v-if="dataPulso.type === 'I'">
              <v-chip :color="priorityColor(dataDetails.priority.relAttr)" class="px-5 ml-1 mr-3 text-h6 col-auto tic__priority--chip">
                {{ priorityName(dataDetails.priority.relAttr) }}
              </v-chip>
            </span>
            <span>
              <v-chip :color="stateColor(dataDetails.status.relAttr)" class="px-5 ml-1 mr-3 text-h6 col-auto">
                {{ this.tags[1].value }}
              </v-chip>
            </span>
          </span>
          <span
            :class="['wrapper__iconTitle',
              $vuetify.breakpoint.mdAndUp ? '' : 'ml-2',
            ]">
            {{ dataDetails.referenceNumber }}-{{ sandetel ? dataDetails.summary.slice(20) : dataDetails.summary }}
          </span>
        </h2>

        <v-spacer
          class="middle-hr"
          :style="{ borderColor: $vuetify.theme.currentTheme.primary }"
        />

        <div
          v-if="$vuetify.breakpoint.mdAndUp"
          class="ticket-actions d-flex flex-row flex-nowrap justify-col-auto px-0"
          :style="{ borderColor: $vuetify.theme.currentTheme.primary }"
        >
          <template v-for="(action, i) in ticketActions">
            <v-btn
              v-if="action.name === 'follow' || action.name === 'follownot' || action.name === 'share'"
              :key="i"
              icon
              class="ml-4"
              :class="[currentAction && action.name === currentAction.name ? 'btn-action' : '']"
              :id='"btn-ticket-action-" + action.name'
              @click.stop="viewAction(action)"
              @mouseover="actionHovered = action.name"
              @mouseleave="actionHovered = null"
            >
              <v-icon v-if="currentAction && action.name === currentAction.name">{{action.iconNegative}}</v-icon>
              <v-icon v-else>{{ action.name === 'follow' ? 'icon-ayudadigital-ojo-negativo' :  action.icon}}</v-icon>

              <div
                :class="[
                  'ticket-action-name',
                  {
                    right: $t(`ticketActions.${action.name}.title`).length > 11,
                  },
                ]"
              >
                <v-scroll-y-transition>
                  <p v-if="actionHovered === action.name" class="text-body mb-0">
                    {{ $t(`ticketActions.${action.name}.title`) }}
                  </p>
                </v-scroll-y-transition>
              </div>
            </v-btn>
          </template>
        </div>
      </div>
      <!-- TITULO -->

      <div
        :class="['container__span__interesados',
          $vuetify.breakpoint.mdAndUp ? '' : 'ml-2',
        ]" v-if="this.isUserInArray && this.isSuscriptor">
        <i class="iconTitle icon-ayudadigital-interesados-negativo"></i>
        <span>
          {{ $t("views.ticketDetail.subscriptions.interesado") }}
        </span>
      </div>
      <div
        :class="['container__span__interesados',
          $vuetify.breakpoint.mdAndUp ? '' : 'ml-2',
        ]"
        v-if="this.isUserInArray && this.isSeguidor">
        <span>
          {{ $t("views.ticketDetail.subscriptions.seguidor") }}
        </span>
      </div>

      <template v-if="mostrarUserCustomer">
        <div class="container__userCustomer">
          <v-card class="card__container">
            <div class="card__element">
              <key-value-table
                :properties="dataUserCustomer(userCustomer)"
                class=""
              >
                <template #value="{ value }" v-if="$vuetify.breakpoint.mdAndUp">
                  <v-list-item-title class="text-right">
                    {{ value }}
                  </v-list-item-title>
                </template>
              </key-value-table>
            </div>
            <v-divider />
          </v-card>
        </div>
      </template>

      <v-spacer></v-spacer>
    </template>
    <!-- END HEADER -->

    <!-- ATTACH -->
    <template  v-if="dataDetails != null && !loadingSuscriptor">
      <v-expand-transition>
        <v-col class="pa-0 ma-0 wrapper-attch" v-if="!!dataDetails.attachments.length">
          <v-card transition="scroll-2n">
            <v-chip-group show-arrows>
              <div class="wrapper__attch--file">
                <v-chip
                  v-for="(processedAttach, i) in processedAttachments"
                  :key="i"
                  class="ma-2 adjuntChip customPaddingFiles"
                  color="white"
                  text-color="primary"
                  label
                  small
                  @click="download(processedAttach.attach.id, processedAttach.attach.name)"
                  :disabled="downloadProccess"
                >
                  <div class="d-flex flex-column">
                    <span class="icon-background">
                      <i
                        :class="['fa-solid', 'fa-2xl', 'pb-1', processedAttach.iconClass.icon.icon]"
                        :style="{ color: processedAttach.iconClass.icon.color }"
                      ></i>
                    </span>
                    <span>{{ processedAttach.attach.name }}</span>
                  </div>
                </v-chip>
              </div>
            </v-chip-group>
          </v-card>
        </v-col>
      </v-expand-transition>
    </template>
    <!-- END ATTACH -->

    <!-- DYNAMIC ACTION FORM -->
    <template>
      <v-card
        v-if="currentAction != null || currentActionVisible"
        class="mt-4 pa-4">
        <v-expand-transition>
          <component
            v-if="currentAction != null && currentActionVisible"
            :is="currentAction.component"
            @refresh:detail="searchDetails()"
            @refresh:activities="searchActivities()"
            @update:detail="
              $emit('request', { type: 'updateTicketData', args: $event })
            "
            @input="currentAction = null"
            :ticket="dataDetails"
            :user="user"
            :formParams="currentAction ? params : {}"
          ></component>
        </v-expand-transition>
      </v-card>
    </template>
    <!-- DYNAMIC ACTION FORM -->

    <!-- REFERENCIA PORTAL -->
    <template v-if="!contenidoReferenciaPortalLoading">
      <v-card class="card__container p-1 mt-2"
        v-if="contenidoReferenciaPortal !== null">
        <div v-html="contenidoReferenciaPortal"></div>
      </v-card>
      <template v-else>
        <v-card class="card__container p-1 mt-2"
          v-if="!isUserTic()">
          <p>No hay contenido para mostrar</p>
        </v-card>
      </template>
    </template>
    <!-- REFERENCIA PORTAL -->

    <template v-if="isUserTic()">
      <!-- PULSO -->
      <div class="mt-4" v-if="loadingSuscriptor">
        <v-card v-for="i in 3" :key="`divider-${i}`" class="mx-0" tile>
          <v-skeleton-loader :key="i" type="list-item-three-line">
          </v-skeleton-loader>
        </v-card>
      </div>
      <template v-if="!loadingSuscriptor && dataPulso != null">
        <v-card class="card__container mt-2">
          <template>
            <div class="p-1" v-show="mostrarPulso">
              <template v-if="isParada">
                <p><strong>{{ $t("views.ticketDetailTic.pulso.openDate") }}</strong>  {{ dataPulso.horaAperturaParada}}</p>
                <p>{{ tiempoRestanteParada() }}</p>
              </template>
              <template v-else-if="sandetel">
                <p><strong>{{ $t("views.ticketDetailTic.pulso.openDate") }}</strong> {{ dataPulso.open_date}}</p>
              </template>
              <template v-else>
                <p><strong>{{ $t("views.ticketDetailTic.pulso.openDate") }}</strong> {{ dataPulso.date}} {{ dataPulso.hour}}</p>
                <p>{{ tiempoTranscurrido(dataPulso.date, dataPulso.hour) }}</p>
              </template>
              <p><strong>{{ $t("views.ticketDetailTic.pulso.resource") }}</strong> {{ dataPulso.nombreRecursoDetalle || dataPulso.resource_name}}</p>
              <p v-if="dataPulso.tipoRecurso"><strong>{{ $t("views.ticketDetailTic.pulso.type") }}</strong> {{ dataPulso.tipoRecurso}}</p>
              <p v-if="dataPulso.type === 'I' && sandetel !== true"><strong>{{ $t("views.ticketDetailTic.pulso.contacts") }}</strong> {{ dataPulso.children}}</p>
              <p><strong>{{ $t("views.ticketDetailTic.pulso.claims") }}</strong> {{ dataPulso.reclamaciones || dataPulso.zreclamaciones}}</p>
              <p
                v-if="!isParada && !sandetel">
                <strong>{{ $t("views.ticketDetailTic.pulso.location") }}</strong>
                <v-btn
                  icon
                  title="Ver mapa"
                  id="no-background-hover"
                  @click="navigateToMap">
                    <v-icon size="30">icon-ayudadigital-chincheta</v-icon>
                </v-btn>
                </p>
            </div>
          </template>
        </v-card>
      </template>
      <!-- PULSO -->

      <!-- ORGANIZAZION -->
      <div class="mt-4" v-if="loadingSuscriptor">
        <v-card v-for="i in 3" :key="`divider-${i}`" class="mx-0" tile>
          <v-skeleton-loader :key="i" type="list-item-three-line">
          </v-skeleton-loader>
        </v-card>
      </div>
      <template v-if="!loadingSuscriptor && dataDetails != null">
        <div class="card__title">
          {{ $t("views.ticketDetailTic.organizacion.title") }}
        </div>
        <v-card class="card__container">
          <template>
            <div class="p-1" v-show="mostrarUsuarioAsignado">
              <p><strong>{{ $t("views.ticketDetailTic.organizacion.user") }}</strong> {{ dataDetails.assignee.name }}</p>
              <p><strong>{{ $t("views.ticketDetailTic.organizacion.location") }}</strong> {{ dataOrganization.org_name }}</p>
              <p><strong>{{ $t("views.ticketDetailTic.organizacion.lastDate") }}</strong> {{ convertTimestamp(dataOrganization.zfecha_ult_asign) || '' }}</p>
            </div>
          </template>
        </v-card>
      </template>
      <!-- ORGANIZAZION -->

      <!-- DETAILS -->
      <div class="mt-4" v-if="loadingSuscriptor">
        <v-card v-for="i in 3" :key="`divider-${i}`" class="mx-0" tile>
          <v-skeleton-loader :key="i" type="list-item-three-line">
          </v-skeleton-loader>
        </v-card>
      </div>
      <template v-if="!loadingSuscriptor && dataDetails != null">
        <div>
          <div class="card__title">
            {{ $t("views.ticketDetail.detailsSectionTitle") }}
          </div>
          <v-card class="card__container">
            <div class="card__element">
              <div v-if="dataDetails.description !== null" class="v-list elevation-2 wrapper__details">
                <p></p>
                <p>
                  <pre id="detailForm" class="mb-0 " style="white-space: pre-wrap;display: flex"><span :class="{'descriptionEllipsis': !this.showFullMessage && showMessageOrNot()}">{{ displayMessage() }}</span><span class="showMoreLink" v-if="!this.showFullMessage && showMessageOrNot()"
                    @click="toggleMessageVisibility()">...{{ $t('views.ticketDetail.detailsMore') }}</span>
                  </pre>
                </p>
                <p></p>
              </div>

              <v-divider v-if="allDataDetails(mostrarListaDeta).length > 0"/>

              <key-value-table
                v-if="allDataDetails(mostrarListaDeta).length > 0"
                :properties="allDataDetails(mostrarListaDeta)"
                class=""
              >
                <template #value="{ value }" v-if="$vuetify.breakpoint.mdAndUp">
                  <v-list-item-title class="text-right">
                    {{ value }}
                  </v-list-item-title>
                </template>
              </key-value-table>

            </div>
            <v-divider v-if="allDataDetails(mostrarListaDeta).length > 0"/>
            <button v-if="counteDeta > 2 || showExpandir" class="container__btnExpand" @click="toggleDeta">
              <v-icon :class="['icon__action', { 'rotate': girarElementoDeta }]">mdi-chevron-down</v-icon>
            </button>
          </v-card>
        </div>
      </template>
      <!-- END DETAILS -->

      <!-- ACTIVITIES -->
      <div class="mt-4" v-if="loadingSuscriptor">
        <v-card v-for="i in 3" :key="`divider-${i}`" class="mx-0" tile>
          <v-skeleton-loader :key="i" type="list-item-three-line">
          </v-skeleton-loader>
        </v-card>
      </div>
      <template v-if="!loadingSuscriptor && dataActivities.length">
        <div>
          <div class="card__title">
            {{ $t("views.ticketDetail.activities.sectionTitle") }}
          </div>
          <v-card class="card__container">
            <div class="card__element" v-for="(activity, i) in dataActivities" v-show="i < 2 || mostrarListaActi" :key="i">
              <v-list-item :key="i">
                <v-list-item-avatar class="mx-0 mx-md-initial">
                  <v-icon left color="primary">{{ activity.icon }}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ activity.type.webDescription }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                    style="max-width: 100%; white-space: initial"
                  >
                    <p
                      v-if="activity.analyst != null && !isCitizen()"
                      class="d-inline-block mt-1 mb-0 mr-4 text-truncate v-align-top"
                      style="max-width: inherit"
                    >
                      <v-icon small left>mdi-account</v-icon>
                      <span>{{ activity.analyst.name }}</span>
                    </p>
                    <p v-if="activity.analyst.organization"
                      class="d-inline-block mt-1 mb-0 mr-4 text-truncate v-align-top"
                      style="max-width: inherit"
                    >
                      <v-icon small left>mdi-sitemap</v-icon>
                      <span>{{ activity.analyst.organization.name }}</span>
                    </p>
                    <p
                      class="d-inline-block mt-1 mb-0 text-no-wrap v-align-top"
                    >
                      <v-icon small left>mdi-calendar</v-icon>
                      <span>{{ activity.date | datetime }}</span>
                    </p>
                    <p
                      v-if="activity.zplanif_motivo_description != null
                      && activity.type.code === 'ACT_PLANI'"
                      class="mt-2 mb-0"
                      style="word-break: break-word"
                    >
                      {{ activity.zplanif_motivo_description }}
                    </p>
                    <p
                      v-if="activity.actionDescription != null"
                      class="d-block mt-2 mb-0 text-truncate"
                      style="max-width: inherit"
                    >
                      <!-- template for transfer from -> to -->
                      <template v-if="activity.type.code === 'ST'">
                        <v-icon small left>mdi-state-machine</v-icon>
                        {{ activity.actionDescription.from }}
                        <v-icon small class="mx-1"
                          >mdi-arrow-right-thick</v-icon
                        >
                        {{ activity.actionDescription.to }}
                      </template>

                      <template v-else>
                        {{ activity.type.code }}
                      </template>
                    </p>
                    <p
                      v-if="activity.description != null"
                      class="mt-2 mb-0"
                      style="word-break: break-word"
                    >
                      {{ activity.description }}
                    </p>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider :key="`divider-${i}`"/>
            </div>
            <button v-if="dataActivities.length > 2" class="container__btnExpand" @click="toggleActi">
              <v-icon :class="['icon__action', { 'rotate': girarElementoActi }]">mdi-chevron-down</v-icon>
            </button>
          </v-card>
        </div>
      </template>
      <!-- END ACTIVITIES -->

      <!-- PLANIFICADA -->
      <div class="mt-4" v-if="loadingSuscriptor">
        <v-card v-for="i in 3" :key="`divider-${i}`" class="mx-0" tile>
          <v-skeleton-loader :key="i" type="list-item-three-line">
          </v-skeleton-loader>
        </v-card>
      </div>
      <template v-if="!loadingSuscriptor && activityPlanin">
        <div>
          <div class="card__title">
            {{ $t("views.ticketDetail.detailsSectionTitle.title") }}
          </div>
          <v-card class="card__container">
            <v-list class="py-md-0">
              <template >
                <v-list-item class="px-0 px-md-4">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ activityPlanin.type.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      style="max-width: 100%; white-space: initial"
                    >
                      <p
                        v-if="activityPlanin.analyst != null && !isCitizen()"
                        class="d-inline-block mt-1 mb-0 mr-4 text-truncate v-align-top"
                        style="max-width: inherit"
                      >
                        <v-icon small left>mdi-account</v-icon>
                        <span>{{ activityPlanin.analyst.name }}</span>
                      </p>
                      <p
                        v-if="dataActivities.call_back_date != null"
                        class="d-inline-block mt-1 mb-0 text-no-wrap v-align-top"
                      >
                        <v-icon small left>mdi-calendar</v-icon>
                        <span>
                          {{ $t("views.ticketDetail.requiredInformation.plannedDate") }}
                          <strong>
                            {{ dataActivities.call_back_date | datetime }}
                          </strong>
                        </span>
                      </p>
                      <p
                        v-if="activityPlanin.zplanif_motivo_description != null"
                        class="mt-2 mb-0"
                        style="word-break: break-word"
                      >
                        {{ activityPlanin.zplanif_motivo_description }}
                      </p>
                      <p
                        v-if="activityPlanin.description != null"
                        class="mt-2 mb-0"
                        style="word-break: break-word"
                      >
                        {{ activityPlanin.description }}
                      </p>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-card>
        </div>
      </template>
      <!-- PLANIFICADA -->

      <!-- WORKFLOW -->
      <div class="mt-4" v-if="loadingSuscriptor">
        <v-card v-for="i in 3" :key="`divider-workflow-${i}`" class="mx-0" tile>
          <v-skeleton-loader :key="i" type="list-item-one-line">
          </v-skeleton-loader>
        </v-card>
      </div>
      <template v-if="!loadingSuscriptor && dataWorkFlow.length > 0">
        <h4 class="mt-4">{{ $t("views.ticketDetail.workFlow.sectionTitle") }}</h4>

        <v-spacer></v-spacer>

        <v-card class="mt-4">
          <v-sheet class="">
            <v-chip-group mandatory class="pa-2">
              <div class="wrapper__workflow">
                <template v-for="(work, i) in dataWorkFlow">
                  <v-chip :key="`chip-${i}`"
                    label :color="work.color"
                    class="chip-workflow"
                  >
                    <v-icon left class="white--text">
                      {{ work.icon }}
                    </v-icon>
                    <span class="white--text">{{ work.contact }}</span>
                  </v-chip>
                  <v-icon class="icon__workflow" v-if="i < dataWorkFlow.length - 1" :key="`icon-${i}`">
                    mdi-arrow-right
                  </v-icon>
                </template>
              </div>
            </v-chip-group>
          </v-sheet>
        </v-card>
      </template>
      <!-- END WORKFLOW -->

      <!-- SUSCRIPCIONES -->
      <div class="mt-4" v-if="loadingSuscriptor">
        <v-card v-for="i in 3" :key="`divider-${i}`" class="mx-0" tile>
          <v-skeleton-loader :key="i" type="list-item-three-line">
          </v-skeleton-loader>
        </v-card>
      </div>
      <template v-if="!loadingSuscriptor && dataDetails != null">
        <div v-if="dataSuscriptorOnly.length > 0">
          <div class="card__title">
            {{ $t("views.ticketDetail.subscriptions.title") }}
          </div>
          <v-card class="card__container">
            <template>
              <v-chip
                v-for="(suscriptorItem, i) in allDataSuscripciones(mostrarListaSuscrip)"
                :key="i"
                class="ma-2"
                :model-value="true"
              >
                {{ suscriptorItem.name }}
              </v-chip>
            </template>
            <v-divider />
            <button class="container__btnExpand" @click="toggleSuscrip">
              <v-icon :class="['icon__action', { 'rotate': girarElementoSuscrip }]">mdi-chevron-down</v-icon>
            </button>
          </v-card>
        </div>
      </template>
      <!-- END SUSCRIPCIONES -->

    </template>
    <!-- FLOATING ACTION BUTTONS -->
    <!-- <v-speed-dial
      v-if="!$vuetify.breakpoint.mdAndUp && !loadingSuscriptor"
      v-model="fab"
      bottom
      right
      direction="top"
      transition="slide-y-reverse-transition"
      class="align-end"
      :style="{
          position: 'fixed',
          bottom: '70px',
          zIndex: '20',
        }"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="primary" dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-menu</v-icon>
        </v-btn>
      </template>

      <div
        v-for="(action, i) in ticketActions"
        :key="i"
        class="d-flex flex-nowrap align-center"
      >
        <v-btn
          v-if="action.name === 'follow' || action.name === 'follownot' || action.name === 'share'"
          class="rounded-pill"
          color="primary--text grey lighten-4"
          dark
          @click.stop="openFabsButton(action)"
        >
          <span class="mr-2">{{ $t(action.key) }}</span>
          <v-icon small>{{ action.icon }}</v-icon>
        </v-btn>
      </div>
    </v-speed-dial> -->
    <!-- FLOATING ACTION BUTTONS -->

    <ShareDialog
      :visible="openDialog"
      @input="openDialog = false"
      :item="sharedItem || {}"
      :positionX="sharedDialogPosition.positionX"
      :positionY="sharedDialogPosition.positionY"
    ></ShareDialog>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import mimeTypes from 'mime-types';
import { KeyValueTable, ListNavigatorPulso, ShareDialog } from '@/components';
import TicketActionsHandler from '@/components/ticket-actions';

const getClient = (type) => Vue.api.getClient(type);

const PLANNED_ACTIVITY = 'ACT_PLANI';
const PLANNED_ACTIVE = 1;
const WORKFLOW_ICON_TYPES = {
  DEFAULT: 'mdi-check-circle-outline',
  REJ: 'mdi-close-circle',
  PEND_ORDER: 'mdi-eye',
  PEND: 'mdi-exclamation',
  END: 'mdi-wrench',
};

const WORKFLOW_COLOR_TYPES = {
  DEFAULT: 'green',
  REJ: 'red',
  PEND_ORDER: 'accent',
  PEND: 'primary',
};

export default {
  name: 'DetailsTicketTicView',
  components: { KeyValueTable, ListNavigatorPulso, ShareDialog },
  props: {
    ticketType: {
      type: String,
      required: true,
    },
    idTicket: {
      type: String || Number,
      required: true,
    },
    listURL: {
      type: String,
      default: () => '/requests',
    },
    pulsoDataExt: {
      type: Object,
      default: () => ({}),
    },
    isTIC: {
      type: Boolean,
      default: () => true,
    },
    listProac: {
      type: Array,
      default: () => [],
    },
    getListProac: {
      type: Function,
    },
  },
  data: () => ({
    panel: 0,
    fab: false,
    actionHovered: null,
    currentAction: null,
    currentActionVisible: false,
    downloadProccess: false,
    zmot_parada: null,
    call_back_date: null,
    isInitFlow: false,
    activityPlanin: null,
    message: [],
    messageAux: [],
    mostrarListaActi: true,
    girarElementoActi: true,
    mostrarListaDeta: true,
    girarElementoDeta: true,
    mostrarListaPlani: false,
    girarElementoPlani: false,
    mostrarUserCustomer: false,
    girarUserCustomer: false,
    mostrarListaSuscrip: true,
    girarElementoSuscrip: true,
    mostrarPulso: true,
    girarElementoPulso: false,
    mostrarUsuarioAsignado: true,
    girarElementoUsuarioAsignado: false,
    showExpandir: false,
    counteDeta: 0,
    userCustomer: {},
    isInfoCustomer: false,
    showFullMessage: true,
    isUserInArray: false,
    isSeguidor: false,
    isSuscriptor: false,

    dataPulso: {},
    dataOrganization: {},
    dataActivities: [],
    dataDetails: {},
    dataWorkFlow: [],
    dataSuscriptor: [],
    dataSuscriptorOnly: [],
    contenidoReferenciaPortal: null,
    contenidoReferenciaPortalLoading: true,

    loadingPulso: true,
    loadingOrganization: true,
    loadingActivities: true,
    loadingDetails: true,
    loadingWorkFlow: true,
    loadingSuscriptor: true,
    codigoInteresado: 400001,
    codigoSeguidor: 400002,
    sandetel: false,
    listViewQuery: '/pulsodigital/incidenciasproactivas',
    isPulso: false,
    sharedItem: null,
    inputTlfno: '',
    tlfnoConverted: '',
    loading: false,
    openDialog: false,
    sharedDialogPosition: {},
    showBtnRetry: false,
    params: {},
  }),
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
      isMobile() {
        return this.$vuetify.breakpoint.mobile;
      },
    }),
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
    tags() {
      return [
        {
          icon: 'mdi-tag-outline',
          value: this.dataDetails.affectedResource.name,
        },
        {
          icon: 'mdi-checkbox-multiple-blank-outline',
          value: this.dataDetails.status.zdescripcion_web
            ? this.dataDetails.status.zdescripcion_web
            : this.dataDetails.status.name,
        },
        {
          icon: 'mdi-check-box-outline',
          value: this.dataDetails.category.name,
        },
      ];
    },
    colors() {
      return this.$getConst('dashboard.filtersColors');
    },
    stateColor() {
      return (state) => {
        let newState = state;
        if (state === 'RCHZ') {
          newState = 'DRCHZ';
        }
        return this.colors[newState] || '#a40e0e';
      };
    },
    ticketActions() {
      const isUserInArray = this.isUserInArray || false;
      const isSeguidor = this.isSeguidor || false;
      const isSuscriptor = this.isSuscriptor || false;
      const ticketSeguidor = {
        isPulso: true,
        isUserInArray,
        isSeguidor,
        isSuscriptor,
      };
      const actions = TicketActionsHandler
        .performTicketActions(this.dataDetails, this.user, this.dataSuscriptor, ticketSeguidor);

      if (this.dataDetails.category.id === this.$getConst('clone.category')) {
        return actions.filter((action) => action.name !== this.$getConst('clone.name'));
      }
      return actions;
    },

    isMobile() {
      const getter = this.$store.getters['globalState/get'];
      return getter('deviceOS') != null;
    },
    processedAttachments() {
      return this.dataDetails.attachments.map((attach) => {
        const mimeType = this.getMimeTypeByFileName(attach.name);
        const iconClass = this.getFontAwesomeIconFromMIME(mimeType);

        return {
          attach,
          mimeType,
          iconClass,
        };
      });
    },
    isParada() {
      // eslint-disable-next-line max-len
      return this.dataPulso.category === process.env.VUE_APP_PULSO_DIGITAL_CATEGORY_PARADA_PLANIFICADA;
    },
  },
  methods: {
    share(evt) {
      console.log('evt', evt);
      evt.preventDefault();
      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
      if (isMobile === true && window.flutter_inappwebview) {
        const args = {
          url: `${window.location.origin}${this.$router.options.base}element/${this.ticketTypeData.toLowerCase()}/${this.elementIdData}`,
          tlfno: this.tlfnoConverted,
        };
        window.flutter_inappwebview.callHandler('shareDataUsingNative', args);
      } else {
        const fullShareUrl = `${process.env.VUE_APP_EXTERNAL_URL}${process.env.VUE_APP_BASE_URL_MICS_SSPA}utils/converter`;
        this.openDialog = true;
        this.sharedItem = {
          url: fullShareUrl,
          tlfno: this.tlfnoConverted,
        };

        const closestButton = evt.target.closest('button');
        const boundingRect = closestButton.getBoundingClientRect();

        this.sharedDialogPosition = {
          positionX: boundingRect.left + (closestButton.offsetWidth / 2),
          positionY: boundingRect.top + (closestButton.offsetHeight / 2),
        };
      }
    },
    async viewItemDetails(idx) {
      const proactList = this.getListProac();
      const item = this.listProac[idx];
      if (item != null) {
        this.$router.push({
          name: 'TicketDetailTicViewProact',
          params: {
            idTicket: item,
            pulsoDataExt: proactList[idx],
            isTIC: true,
            list: this.listProac,
            getListProac: this.getListProac,
          },
        });
        this.searchDetails('request', item, this.user, proactList[idx], true);
      }
    },
    toggleActi() {
      this.mostrarListaActi = !this.mostrarListaActi;
      this.girarElementoActi = !this.girarElementoActi;
    },
    toggleDeta() {
      if (this.showFullMessage === false
      || (this.mostrarListaDeta === false && this.showFullMessage === false)) {
        this.toggleMessageVisibility();
      }
      this.mostrarListaDeta = !this.mostrarListaDeta;
      this.girarElementoDeta = !this.girarElementoDeta;
    },
    toggleUserCustomer() {
      this.mostrarUserCustomer = !this.mostrarUserCustomer;
      this.girarUserCustomer = !this.girarUserCustomer;
    },
    toggleSuscrip() {
      this.mostrarListaSuscrip = !this.mostrarListaSuscrip;
      this.girarElementoSuscrip = !this.girarElementoSuscrip;
    },
    togglePulso() {
      this.mostrarPulso = !this.mostrarPulso;
      this.girarElementoPulso = !this.girarElementoPulso;
    },
    toggleUsuarioAsignado() {
      this.mostrarUsuarioAsignado = !this.mostrarUsuarioAsignado;
      this.girarElementoUsuarioAsignado = !this.girarElementoUsuarioAsignado;
    },
    async searchDetails(ticketType, idTicket, user, pulsoData, isTIC) {
      this.loadingPulso = true;
      this.loadingOrganization = true;
      this.loadingActivities = true;
      this.loadingDetails = true;
      this.loadingWorkFlow = true;
      this.loadingSuscriptor = true;

      try {
        // DETAILS
        const detailsPromise = await getClient('ticket/request').detail(
          ticketType,
          idTicket,
          (user || {}).id,
          {},
          true,
        ).then((responseDetails) => responseDetails.list[0]);

        this.dataDetails = detailsPromise;
        // PULSO
        let pulsoPromise;
        if (this.sandetel) {
          // pulsoPromise = Promise.resolve(pulsoData);
          pulsoPromise = this.searchPulso(idTicket);
        } else if (this.isEmpty(pulsoData) || pulsoData?.persid === undefined) {
          pulsoPromise = this.searchPulso(idTicket);
        } else {
          pulsoPromise = Promise.resolve(pulsoData);
        }
        // const pulsoPromise = (this.isEmpty(pulsoData) || pulsoData?.persid === undefined)
        //   ? this.searchPulso(idTicket)
        //   : Promise.resolve(pulsoData);
        // ORGANIZACION
        const organizationPromise = pulsoPromise.then(async (dataPulso) => {
          this.dataPulso = dataPulso;
          if (dataPulso.category
            && !(dataPulso.category === process.env.VUE_APP_PULSO_DIGITAL_CATEGORY_PARADA_PLANIFICADA) // eslint-disable-line
            && !this.isUserTic()) {
            this.$store.dispatch('messages/createNotificationMessage', {
              title: 'No tienes permiso para visualizar esta solicitud',
              type: 'error',
              timeout: this.$getConst('notifications.timeoutPlus'),
              dismissible: true,
            });

            this.$router.push('/');
            return null;
          }
          console.log('DATA PULSO ======', this.dataPulso);
          if (dataPulso
            && dataPulso.referenciaPortal
            && dataPulso.referenciaPortal !== null) {
            try {
              const referenciaPortal = await this.$api.getClient('solicitudes').getReferenciaPortal(dataPulso.referenciaPortal);
              this.contenidoReferenciaPortal = referenciaPortal.data.datos.atributos.noticia.procesado; // eslint-disable-line
              this.contenidoReferenciaPortalLoading = false;
            } catch (err) {
              console.log('Error al recoger la referencia del portal', err);
              this.contenidoReferenciaPortalLoading = false;
            }
          } else {
            this.contenidoReferenciaPortalLoading = false;
          }
          return this.searchOrganization(idTicket, detailsPromise.relAttr);
        });
        // ACTIVIDADES
        const activitiesPromise = pulsoPromise
          .then(() => this.searchActivities(idTicket, isTIC, detailsPromise.relAttr));
        // WORKFLOW
        const workflowPromise = this.searchWorkFlow(idTicket);
        // SUSCRIPTOR
        const suscriptorPromise = pulsoPromise
          .then(() => this.searchSuscriptor(detailsPromise.name).then((resSuscriptor) => {
            this.dataSuscriptorOnly = resSuscriptor
              .filter((item) => item.codigoFlujo === this.codigoInteresado);

            this.checkTypeUsers(resSuscriptor, this.user);
            return resSuscriptor;
          }));
        const [
          pulsoDataResult,
          organizationResult,
          activitiesResult,
          workflowResult,
          suscriptorResult,
        ] = await Promise.all([
          pulsoPromise,
          organizationPromise,
          activitiesPromise,
          workflowPromise,
          suscriptorPromise,
        ]);

        this.dataPulso = pulsoDataResult;
        [this.dataOrganization] = organizationResult;
        this.dataActivities = activitiesResult;
        this.dataWorkFlow = workflowResult;
        this.dataSuscriptor = suscriptorResult;
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingPulso = false;
        this.loadingOrganization = false;
        this.loadingActivities = false;
        this.loadingDetails = false;
        this.loadingWorkFlow = false;
        this.loadingSuscriptor = false;
      }
    },
    checkTypeUsers(array, user) {
      array.forEach((item) => {
        if (item.uuid === user.id) {
          this.isUserInArray = true;
          if (item.codigoFlujo === this.codigoSeguidor) {
            this.isSeguidor = true;
          } else {
            this.isSuscriptor = true;
          }
        }
      });
    },
    async searchPulso(idTicket) {
      const session = this.$store.getters['session/user'];
      const categoryEnv = process.env.VUE_APP_PULSO_DIGITAL_CATEGORY_PARADA_PLANIFICADA;
      if (this.sandetel) {
        const filters = {
          statusIncidencia: ['OP', 'DEL', 'PL_ENT', 'FIX'],
        };
        try {
          const response = await this.$api.getClient('solicitudes').getSandetel(filters);
          const ticketPulso = [];
          if (this.sandetel) {
            // eslint-disable-next-line no-restricted-syntax
            response.forEach((tickect) => {
              if (tickect.label.includes(idTicket)) {
                ticketPulso.push(tickect);
              }
            });
          } else {
            // eslint-disable-next-line no-restricted-syntax
            for (const [, tickets] of Object.entries(response)) {
              tickets.forEach((tickect) => {
                if (tickect.persid.includes(idTicket)) {
                  ticketPulso.push(tickect);
                }
              });
            }
          }

          if (this.isEmpty(ticketPulso)) {
            this.$store.dispatch('messages/createNotificationMessage', {
              title: this.$t('ticketActions.noView'),
              type: 'error',
              timeout: this.$getConst('notifications.timeoutPlus'),
              dismissible: true,
            });

            this.$router.push('/');
          }

          return ticketPulso[0];
        } catch (err) {
          console.error(err);
          return err;
        }
      } else {
        const filters = {
          category: categoryEnv,
          statusParada: ['OP', 'DEL', 'CL'],
          statusIncidencia: ['OP', 'DEL', 'PL_ENT', 'FIX'],
          userNodo: session.znodoId,
        };
        try {
          const response = await this.$api.getClient('solicitudes').getParadas(filters);
          const ticketPulso = [];

          // eslint-disable-next-line no-restricted-syntax
          for (const [, tickets] of Object.entries(response)) {
            tickets.forEach((tickect) => {
              if (tickect.persid.includes(idTicket)) {
                ticketPulso.push(tickect);
              }
            });
          }

          if (this.isEmpty(ticketPulso)) {
            this.$store.dispatch('messages/createNotificationMessage', {
              title: this.$t('ticketActions.noView'),
              type: 'error',
              timeout: this.$getConst('notifications.timeoutPlus'),
              dismissible: true,
            });

            this.$router.push('/');
          }

          return ticketPulso[0];
        } catch (err) {
          console.error(err);
          return err;
        }
      }
    },

    async searchOrganization(idTicket, persid) {
      try {
        const response = await this.userClient.getUserOrganization(idTicket, persid);
        return response.organization.data;
      } catch (err) {
        console.error(err);
        return err;
      }
    },
    async searchActivities(idTicket, isTIC, persId) {
      try {
        const isPulso = true;
        const req = getClient('activities').list(0, null, { idTicket }, 'time_stamp desc', isTIC, persId, isPulso);
        const response = await req;
        const respondeAux = req.format(response).list;
        return respondeAux;
      } catch (err) {
        console.error(err);
        return err;
      }
    },
    async searchWorkFlow(idTicket) {
      try {
        const response = await getClient('zapprlWorkFlow').list(idTicket);
        const respondeAux = response.list.sort((workA, workB) => workA.order - workB.order);
        return respondeAux;
      } catch (err) {
        console.error(err);
        return err;
      }
    },
    async searchSuscriptor(referenceNumber) {
      const uuidAplicacionOrigen = this.$getConst('uuidAplicacion.origen');

      try {
        const { id, userid } = this.$store.getters['session/user'];
        const response = await this.suscriptorsClient.getListSuscriptorsSolicitud({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: `cges/solicitudes/${ referenceNumber }/suscriptores?uuidAplicacionOrigen=${ uuidAplicacionOrigen }`,
          },
          id: referenceNumber,
        });

        let arrSus = [];
        if (response?.collection_suscriptors?.suscriptors.length > 0) {
          arrSus = response.collection_suscriptors.suscriptors.map((item) => ({
            name: item.nombre,
            uuid: item.uuid,
            codigoFlujo: item.flujo.id,
          }));
        }

        return arrSus;
      } catch (err) {
        console.error(err);
        return err;
      }
    },

    navigateTo(path) {
      if (this.$router.currentRoute.path !== path) {
        this.$router.push({ path });
        this.$router.go(0);
      }
    },
    getOpenedBy(detail) {
      const openedBy = ['requestedBy', 'customer'].map(
        (key) => (detail[key] || {}).name,
      );
      return openedBy.filter((key, i, arr) => arr.indexOf(key) === i);
    },
    viewAction(action) {
      if (this.currentAction == null || this.currentAction.name !== action.name) {
        this.currentAction = action;
      } else {
        this.currentAction = null;
      }
    },
    openFabsButton(action) {
      this.currentAction = null;

      if (action.name === 'share') {
        this.openDialog = false;
      }

      this.$nextTick(() => {
        this.currentAction = action;

        if (action.name === 'share') {
          this.openDialog = true;
        }

        this.fab = false;
      });
    },
    async download(attachId, nameFile) {
      if (!this.isMobile) {
        this.downloadProccess = true;
      }
      await this.$api.getClient('ticket').download(this.dataDetails.id, attachId, this.dataDetails.referenceNumber, nameFile);
      if (!this.isMobile) {
        this.downloadProccess = false;
      }
    },
    iconWorkFlow(orderTicket, status, position) {
      let icon = WORKFLOW_ICON_TYPES.DEFAULT;
      if (position) {
        icon = WORKFLOW_ICON_TYPES.END;
      } else if (status === 'PEND') {
        icon = (this.dataDetails || {}).approbalWorkflowOrder === String(orderTicket)
          ? WORKFLOW_ICON_TYPES.PEND_ORDER : WORKFLOW_ICON_TYPES.PEND;
      } else if (status === 'REJ') {
        icon = WORKFLOW_ICON_TYPES.REJ;
      }
      return icon;
    },
    colorWorkFlow(orderTicket, status) {
      let color = WORKFLOW_COLOR_TYPES.DEFAULT;
      if (status === 'PEND') {
        color = (this.dataDetails || {}).approbalWorkflowOrder === String(orderTicket)
          ? WORKFLOW_COLOR_TYPES.PEND_ORDER : WORKFLOW_COLOR_TYPES.PEND;
      } else if (status === 'REJ') {
        color = WORKFLOW_COLOR_TYPES.REJ;
      }
      return color;
    },
    isCitizen() {
      return this.user.hasIosUser();
    },
    updateInitFlow() {
      this.isInitFlow = true;
    },
    allDataDetails(type) {
      let arrData = [];
      const basicData = this.basicDetails();
      const additionalData = this.additionalDetails();
      const allData = [...basicData, ...additionalData];

      this.counteDeta = allData.length || 0;

      if (type) {
        arrData = allData;
      } else {
        arrData = allData.slice(0, 2);
      }

      return arrData;
    },
    basicDetails() {
      return this.dataDetails.properties
        .filter((item) => item.name !== 'initialAssignee')
        .map(({ name, value }) => ({
          icon: 'mdi-cog',
          key: name,
          value,
        }));
    },
    additionalDetails() {
      const data = [];

      if (this.dataDetails.parent && this.dataDetails.claimType) {
        data.push(
          {
            key: (this.dataDetails.category || {}).id === this.$getConst('claim.category')
              ? 'views.ticketDetail.additionalInfo.isClaimFromParent' : 'views.ticketDetail.additionalInfo.isClaimFromOrigin',
            icon: 'mdi-arrow-left-right',
            value: this.dataDetails.parent.referenceNumber,
            claim: true,
          },
          {
            key: 'views.ticketDetail.additionalInfo.claimType',
            icon: 'mdi-exclamation-thick',
            value: this.dataDetails.claimType.name,
          },
        );
      }

      data.map((additionalDetail) => ({
        ...additionalDetail,
        key: this.$t(additionalDetail.key),
      }));

      this.getPlannedActivity();

      return data;
    },
    getPlannedActivity() {
      const activities = [];
      const {
        zmot_parada: zmotParada,
        call_back_date: callBackDate,
      } = this.dataDetails;

      if (
        this.dataActivities.length === 0
        || zmotParada == null
        || callBackDate == null
      ) return activities;

      const btnAction = document.getElementById('btn-ticket-action-comment');
      const listActivities = this.dataActivities
        .filter(({ zplanif_motivo: planifMotivo, type, zcheck }) => (
          planifMotivo === zmotParada
          && zcheck === PLANNED_ACTIVE
          && type.code === PLANNED_ACTIVITY
        ));

      if (
        listActivities.length > 0
        && !this.isInitFlow
        && btnAction
      ) {
        listActivities.sort((a, b) => b.date - a.date);
        this.activityPlanin = { ...listActivities[0] };
        btnAction.click();
      }
      this.updateInitFlow();
      return listActivities[0];
    },
    dataUserCustomer(data) {
      return this.formatDataUserCustomer(data);
    },
    formatDataUserCustomer(data) {
      const arrData = [];
      if (data) {
        const dataOrganizacionFuncional = {
          icon: 'mdi-cog',
          key: 'Organización Funcional',
          value: data.organizacionFuncional,
        };
        arrData.push(dataOrganizacionFuncional);

        const dataUbicacionFisica = {
          icon: 'mdi-cog',
          key: 'Centro',
          value: data.ubicacionFisica.edificio.nombre,
        };
        arrData.push(dataUbicacionFisica);

        const dataCargo = {
          icon: 'mdi-cog',
          key: 'Categoría Profesional',
          value: data.cargo.nombre,
        };
        arrData.push(dataCargo);

        const dataTelefono = {
          icon: 'mdi-cog',
          key: 'Teléfono',
          value: data.telefonoPreferente,
        };
        arrData.push(dataTelefono);

        const dataEmail = {
          icon: 'mdi-cog',
          key: 'Email',
          value: data.email,
        };
        arrData.push(dataEmail);
      }
      return arrData;
    },
    allDataSuscripciones(type) {
      let arrData = [];
      const allData = this.dataSuscriptor
        .filter((item) => item.codigoFlujo === this.codigoInteresado);

      if (type) {
        arrData = allData;
      }

      return arrData;
    },
    initToggleMessageVisibility() {
      this.showFullMessage = false;
      this.mostrarListaDeta = false;
      this.girarElementoDeta = false;
    },
    toggleMessageVisibility() {
      this.showFullMessage = !this.showFullMessage;
    },
    displayMessage() {
      const messageAux = this.dataDetails.description || '';
      const characterMax = messageAux ? this.descriptionShowCharacter(messageAux.length) : this.$getConst('ticketDetailView.character');
      if (this.showFullMessage) {
        return messageAux;
      }
      this.showExpandir = messageAux.length > characterMax;
      return messageAux.length > characterMax
        ? `${messageAux.slice(0, characterMax)}`
        : messageAux;
    },
    descriptionShowCharacter(messageAux) {
      let characterCalc = 50;
      if (window.screen.width >= 1024) {
        characterCalc = messageAux;
      }
      return characterCalc;
    },
    showMessageOrNot() {
      const characterMax = this.$getConst('ticketDetailView.character');
      const messageAux = this.dataDetails.description || '';
      if (window.screen.width < 1024) {
        return messageAux.length > characterMax;
      }
      if (window.screen.width >= 1024 && window.screen.width < 1440) {
        return messageAux.length > 100;
      } if (window.screen.width >= 1440 && window.screen.width < 1980) {
        return messageAux.length > 140;
      }
      return messageAux.length > 200;
    },
    getMimeTypeByFileName(fileName) {
      return mimeTypes.lookup(fileName);
    },
    getFontAwesomeIconFromMIME(mimeType) {
      const iconClasses = {
        'image/png': {
          icon: 'fa-file-image',
          color: '#27846D',
        },
        'image/bmp': {
          icon: 'fa-file-image',
          color: '#27846D',
        },
        'image/jpeg': {
          icon: 'fa-file-image',
          color: '#27846D',
        },
        'image/x-png': {
          icon: 'fa-file-image',
          color: '#27846D',
        },
        'image/gif': {
          icon: 'fa-file-image',
          color: '#27846D',
        },
        'audio/mpeg': {
          icon: 'fa-file-audio',
          color: '#27846D',
        },
        'audio/x-ms-wma': {
          icon: 'fa-file-audio',
          color: '#27846D',
        },
        'audio/mp4': {
          icon: 'fa-file-audio',
          color: '#27846D',
        },
        'video/x-msvideo': {
          icon: 'fa-file-video',
          color: '#27846D',
        },
        'video/mpeg': {
          icon: 'fa-file-video',
          color: '#27846D',
        },
        'video/mp4': {
          icon: 'fa-file-video',
          color: '#27846D',
        },
        'application/pdf': {
          icon: 'fa-file-pdf',
          color: '#ff0000',
        },
        'application/msword': {
          icon: 'fa-file-word',
          color: '#1B5EBE',
        },
        'application/vnd.ms-word': {
          icon: 'fa-file-word',
          color: '#1B5EBE',
        },
        'application/vnd.oasis.opendocument.text': {
          icon: 'fa-file-word',
          color: '#1B5EBE',
        },
        'application/vnd.openxmlformats-officedocument.wordprocessingml': {
          icon: 'fa-file-word',
          color: '#1B5EBE',
        },
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
          icon: 'fa-file-word',
          color: '#1B5EBE',
        },
        'application/vnd.ms-excel': {
          icon: 'fa-file-excel',
          color: '#10793F',
        },
        'application/vnd.openxmlformats-officedocument.spreadsheetml': {
          icon: 'fa-file-excel',
          color: '#10793F',
        },
        'application/vnd.oasis.opendocument.spreadsheet': {
          icon: 'fa-file-excel',
          color: '#10793F',
        },
        'application/vnd.ms-excel.sheet.binary.macroenabled.12': {
          icon: 'fa-file-excel',
          color: '#10793F',
        },
        'application/vnd.ms-powerpoint': {
          icon: 'fa-file-powerpoint',
          color: '#C13B1B',
        },
        'application/vnd.openxmlformats-officedocument.presentationml': {
          icon: 'fa-file-powerpoint',
          color: '#C13B1B',
        },
        'application/vnd.oasis.opendocument.presentation': {
          icon: 'fa-file-powerpoint',
          color: '#C13B1B',
        },
        'text/plain': {
          icon: 'fa-file-text',
          color: '#27846D',
        },
        'text/html': {
          icon: 'fa-file-code',
          color: '#27846D',
        },
        'application/json': {
          icon: 'fa-file-code',
          color: '#27846D',
        },
        'application/gzip': {
          icon: 'fa-file-archive',
          color: '#27846D',
        },
        'application/zip': {
          icon: 'fa-file-archive',
          color: '#27846D',
        },
      };

      const iconClass = {
        icon: {
          icon: 'fa-file',
          color: '#27846D',
        },
      };

      Object.keys(iconClasses).forEach((key) => {
        if (mimeType === key) {
          iconClass.icon = iconClasses[key];
        }
      });

      return iconClass;
    },
    findInteresado() {
      const { id } = this.$store.getters['session/user'];
      return this.dataSuscriptor.some((suscriptor) => suscriptor.uuid === id);
    },

    tiempoTranscurrido(fechaStr, horaStr) {
      let resultado = '';
      if (fechaStr || horaStr) {
        const [dia, mes, anio] = fechaStr.split('/').map(Number);
        const [hora, minuto] = horaStr.split(':').map(Number);
        const fechaDada = new Date(anio, mes - 1, dia, hora, minuto);

        const fechaActual = new Date();

        const diferenciaMs = fechaActual - fechaDada;

        const msPorDia = 24 * 60 * 60 * 1000;
        const msPorHora = 60 * 60 * 1000;
        const msPorMinuto = 60 * 1000;

        const dias = Math.floor(diferenciaMs / msPorDia);
        const horas = Math.floor((diferenciaMs % msPorDia) / msPorHora);
        const minutos = Math.floor((diferenciaMs % msPorHora) / msPorMinuto);

        const partes = [];

        if (dias > 0) partes.push(dias === 1 ? `${dias} día` : `${dias} días`);
        if (horas > 0) partes.push(horas === 1 ? `${horas} hora` : `${horas} horas`);
        if (minutos > 0) partes.push(minutos === 1 ? `${minutos} minuto` : `${minutos} minutos`);

        resultado = '(Hace ';
        if (partes.length > 1) {
          const ultimaParte = partes.pop();
          resultado += `${ partes.join(', ') } y ${ ultimaParte }`;
        } else {
          resultado += partes.join('');
        }
      }

      return `${ resultado })`;
    },
    tiempoRestanteParada() {
      const fechaInicio = this.allDataDetails(this.mostrarListaDeta).find((detalle) => detalle.key === 'Fecha y hora de inicio').value;
      const fechaFin = this.allDataDetails(this.mostrarListaDeta).find((detalle) => detalle.key === 'Fecha y hora de fin').value;
      const msPorDia = 24 * 60 * 60 * 1000;
      const msPorHora = 60 * 60 * 1000;
      const msPorMinuto = 60 * 1000;

      const fechaPartsInicio = fechaInicio.split(' ');
      const diaMesAnioInicio = fechaPartsInicio[0].split('/');
      const horaInicio = fechaPartsInicio[3];

      const fechaPartsFin = fechaFin.split(' ');
      const diaMesAnioFin = fechaPartsFin[0].split('/');
      const horaFin = fechaPartsFin[3];

      const fechaDadaInicio = new Date(`${diaMesAnioInicio[2]}-${diaMesAnioInicio[1]}-${diaMesAnioInicio[0]}T${horaInicio}:00`);
      const fechaDadaFin = new Date(`${diaMesAnioFin[2]}-${diaMesAnioFin[1]}-${diaMesAnioFin[0]}T${horaFin}:00`);
      const fechaActual = new Date();

      const diferenciaMsInicio = fechaDadaInicio - fechaActual;
      const diferenciaMsFin = fechaDadaFin - fechaActual;

      if (diferenciaMsInicio > 0) {
        const difAux = diferenciaMsInicio;

        const dias = Math.floor(difAux / msPorDia);
        const horas = Math.floor((difAux % msPorDia) / msPorHora);
        const minutos = Math.floor((difAux % msPorHora) / msPorMinuto);

        const partes = [];

        if (dias > 0) partes.push(dias === 1 ? `${dias} día` : `${dias} días`);
        if (horas > 0) partes.push(horas === 1 ? `${horas} hora` : `${horas} horas`);
        if (minutos > 0) partes.push(minutos === 1 ? `${minutos} minuto` : `${minutos} minutos`);

        let resultado = '(Quedan ';
        if (partes.length > 1) {
          const ultimaParte = partes.pop();
          resultado += `${ partes.join(', ') } y ${ ultimaParte }`;
        } else {
          resultado += partes.join('');
        }

        return `${ resultado })`;
      }

      if (diferenciaMsFin > 0) {
        const difAux = diferenciaMsFin;

        const dias = Math.floor(difAux / msPorDia);
        const horas = Math.floor((difAux % msPorDia) / msPorHora);
        const minutos = Math.floor((difAux % msPorHora) / msPorMinuto);

        const partes = [];

        if (dias > 0) partes.push(dias === 1 ? `${dias} día` : `${dias} días`);
        if (horas > 0) partes.push(horas === 1 ? `${horas} hora` : `${horas} horas`);
        if (minutos > 0) partes.push(minutos === 1 ? `${minutos} minuto` : `${minutos} minutos`);

        let resultado = '(Faltan ';
        if (partes.length > 1) {
          const ultimaParte = partes.pop();
          resultado += `${ partes.join(', ') } y ${ ultimaParte }`;
        } else {
          resultado += partes.join('');
        }

        return `${ resultado } para que finalice la intervención)`;
      }

      return null;
    },
    convertTimestamp(timestamp) {
      const date = new Date(timestamp * 1000);

      let day = date.getDate();
      let month = date.getMonth() + 1;
      const year = date.getFullYear().toString().slice(-2);
      let hours = date.getHours();
      let minutes = date.getMinutes();

      day = day < 10 ? `0${ day}` : day;
      month = month < 10 ? `0${ month}` : month;
      hours = hours < 10 ? `0${ hours}` : hours;
      minutes = minutes < 10 ? `0${ minutes}` : minutes;

      const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;

      return formattedDate;
    },
    priorityColor(priority) {
      switch (priority) {
      case 3:
        return '#F9F1BC';
      case 4:
        return '#F4D4AA';
      case 5:
        return '#FF7858';
      default:
        return '#FF7858';
      }
    },
    priorityName(priority) {
      switch (priority) {
      case 3:
        return 'Media';
      case 4:
        return 'Alta';
      case 5:
        return 'Muy alta';
      default:
        return 'Muy alta';
      }
    },
    isEmpty(obj) {
      return obj === null || obj === undefined || Object.keys(obj).length === 0;
    },
    isUserTic() {
      const user = this.$store.getters['session/user'];
      return user.accessTypeTic;
    },
    navigateToMap() {
      let refNum;
      let nombreRecursoDetalle;

      if (this.sandetel) {
        refNum = this.dataPulso.ref_num;
        nombreRecursoDetalle = this.dataPulso.resource_name;
      } else {
        refNum = this.dataPulso.REF_NUM;
        nombreRecursoDetalle = this.dataPulso.nombreRecursoDetalle;
      }
      this.$router.push({
        name: 'PulsoDigitalMap',
        params: {
          id: `${refNum} ${nombreRecursoDetalle}`,
        },
      });
    },
    historyBack() {
      this.$router.push('/pulsodigital');
    },
    async seguirTicket() {
      const messageId = await this.$store.dispatch(
        'messages/createNotificationMessage',
        {
          icon: 'progress-circular',
          title: this.$tc('views.ticketDetailTic.send.creating'),
        },
      );

      const { referenceNumber } = this.dataDetails;
      try {
        const { id, userid } = this.$store.getters['session/user'];
        const response = await this.suscriptorsClient.postSuscriptors({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: `cges/solicitudes/${ referenceNumber }/suscriptores`,
          },
          id: referenceNumber,
          suscriptorAll: id,
          flujo: {
            id: this.codigoSeguidor,
          },
        });

        if (response.status === 200) {
          this.isErrorCreate = false;
          this.isSeguidor = true;
          this.isUserInArray = true;
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'success',
            icon: 'mdi-check-circle',
            title: `${this.$t('views.ticketDetailTic.send.ok')}`,
            timeout: this.$getConst('notifications.timeout'),
          });
        } else {
          this.isErrorCreate = true;
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'error',
            icon: 'mdi-close-circle',
            title: this.$tc('views.ticketDetailTic.send.ko'),
            timeout: this.$getConst('notifications.timeout'),
          });
        }
      } catch (error) {
        this.isErrorCreate = true;
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'error',
          icon: 'mdi-close-circle',
          title: this.$tc('views.ticketDetailTic.send.ko'),
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    async dejarSeguirTicket() {
      const messageId = await this.$store.dispatch(
        'messages/createNotificationMessage',
        {
          icon: 'progress-circular',
          title: this.$tc('views.ticketDetailTic.send.creating'),
        },
      );

      const { referenceNumber } = this.dataDetails;
      try {
        const { id, userid } = this.$store.getters['session/user'];
        const response = await this.suscriptorsClient.deleteSuscriptors({
          apiCges: {
            delegado: userid,
            endpoint: `cges/solicitudes/${ referenceNumber }/suscriptores/${ id }`,
          },
          id: referenceNumber,
          uuid: id,
        });

        if (response.status === 200) {
          this.isErrorCreate = false;
          this.isSeguidor = false;
          this.isUserInArray = false;
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'success',
            icon: 'mdi-check-circle',
            title: `${this.$t('views.ticketDetailTic.send.ok')}`,
            timeout: this.$getConst('notifications.timeout'),
          });
        } else {
          this.isErrorCreate = true;
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'error',
            icon: 'mdi-close-circle',
            title: this.$tc('views.ticketDetailTic.send.ko'),
            timeout: this.$getConst('notifications.timeout'),
          });
        }
      } catch (error) {
        this.isErrorCreate = true;
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'error',
          icon: 'mdi-close-circle',
          title: this.$tc('views.ticketDetailTic.send.ko'),
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
  },
  created() {
    this.isPulso = window.location.href.includes('pulsodigital');
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    this.sandetel = window.location.pathname.includes('incidenciasproactivas');
    if (
      (this.pulsoDataExt.category
      && !(this.pulsoDataExt.category === process.env.VUE_APP_PULSO_DIGITAL_CATEGORY_PARADA_PLANIFICADA) // eslint-disable-line
      && !this.isUserTic())
      || this.isCitizen()) {
      this.$store.dispatch('messages/createNotificationMessage', {
        title: 'No tienes permiso para visualizar esta solicitud',
        type: 'error',
        timeout: this.$getConst('notifications.timeoutPlus'),
        dismissible: true,
      });

      this.$router.push('/');
    } else {
      this.userClient = this.$api.getClient('user');
      this.suscriptorsClient = this.$api.getClient('suscriptors');
      const {
        ticketType,
        idTicket,
        user,
        pulsoDataExt,
        isTIC,
        // listProac,
      } = this;
      this.searchDetails(ticketType, idTicket, user, pulsoDataExt, isTIC);
    }
    this.$root.$on('updateFollow', () => {
      this.isUserInArray = true;
      this.isSeguidor = true;
      this.isSuscriptor = false;
    });

    this.$root.$on('updateFollownot', () => {
      this.isUserInArray = false;
      this.isSeguidor = false;
      this.isSuscriptor = false;
    });
  },
  watch: {
    currentAction(newval, oldval) {
      console.log('current action changed from', oldval, 'to', newval);
      if (newval == null) {
        // wait for transition end to hide the card container
        setTimeout(() => {
          this.currentActionVisible = false;
        }, 200);
      } else {
        this.$nextTick(() => {
          this.currentActionVisible = true;
        });
      }
      return newval;
    },
  },
};
</script>
<style lang="scss">
$section-min-height: 24px;

.v-slide-group__next--disabled, .v-slide-group__prev--disabled {
  display: none;
}

.v-slide-group__next, .v-slide-group__prev {
  min-width: 42px !important;
}

#ticket-detail-view {
  .v-expansion-panel--active > .v-expansion-panel-header {
    min-height: initial;
  }

  .icon-ayudadigital-exportar::before  {
    color:grey !important;
    font-weight: bold !important;
  }

  .icon-ayudadigital-escalar::before  {
    color:grey !important;
    font-weight: bold !important;
  }

  .icon-ayudadigital-accion-interesados::before  {
    color: rgba(0, 0, 0, 0.54);
    font-size: 32px;
  }

  .section-mh {
    min-height: $section-min-height;
  }

  .mw-100 {
    max-width: 100%;
  }

  .v-align-top {
    vertical-align: top;
  }

  .v-expansion-panel-content__wrap {
    padding: 0 8px;

    @media (min-width: 960px) {
      padding: initial;
    }
  }

  .v-speed-dial__list {
    align-items: flex-end;
  }
}

.v-application--is-ltr .v-expansion-panel-header__icon {
  margin: 0 auto;
}
.showMoreLink {
    color: #27846d;
    cursor: pointer;
    font-size: 14px;
    margin-left: 0.25rem;
    display: flex;
    align-items: end;
    /*text-decoration: underline;*/
}
.descriptionEllipsis{
    max-width: 95%;
    white-space: nowrap !important;
    overflow: hidden !important;
    margin-right: 0.25rem;
}
</style>

<style lang="scss" scoped>
$ticket-action-button-size: 55px;
$ticket-action-bottom: -45px;
$ticket-action-last-item-right: -40px;
$ticket-action-last-item-right-mdandup: -50px;

#title {
  word-break: break-word;

  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  hyphens: auto;
}
.middle-hr {
  border-color: inherit;
  border-width: 1px 0;
  border-style: solid;
}

.ticket-actions {
  position: relative;

  > button {
    width: $ticket-action-button-size;
    height: $ticket-action-button-size;
    border-radius: 50%;
    border-color: inherit;
    border-width: 2px;
    border-style: solid;
    background-color: white;

    &:last-child .ticket-action-name.right {
      left: 100%;
      display: table;
      transform: translateX(-100%);
    }
  }
  .ticket-action-name {
    pointer-events: none;
    position: absolute;
    bottom: $ticket-action-bottom;
    left: 50%;
    transform: translateX(-50%);
  }
}
.primary--border {
  border-width: 1px;
  border-style: solid;
}
.chip-workflow {
  pointer-events: none;
}
.wrapper__details {
  background-color: #ffffff;
  display: block;
  padding: 12px;
  border-radius: 4px;
  box-shadow: none !important;
}
.wrapper-attch {
  margin-top: 2rem !important;
}
.mt-0 {
  margin-top: 0;
}
.separator__table {
  border-color: #dedede;
}
.btn__more {
  background-color: transparent !important;
  cursor: pointer;
  border: none;
  color: #27846d;
  padding: 0 !important;
  height: initial !important;
  box-shadow: none;
}
.wrapper-btn {
  display: flex;
  flex-direction: row;
  justify-content: end;
}
.wrapper__workflow {
  display: flex;
  flex-wrap: wrap;
}
.kaiPlus > .v-slide-group__wrapper > .v-slide-group__content {
  background-color: red;
  justify-content: end!important;
}
.wrapper__attch--file {
  display: flex;
  width: 100%;
  justify-content: end;
}
.mt-2 {
  margin-top: 2rem!important;
}
.pb-5 {
  padding-bottom: 5rem!important;
}
.p-1 {
  padding: 1rem;
}
.header__expansion--title {
  color: #27846d !important;
  font-size: 0.875rem;
}

.fade-in {
  opacity: 1;
  transition: opacity 0.5s ease-in;
}

.fade-out {
  opacity: 0;
  transition: opacity 0.5s ease-out;
}

button i {
  transition: transform 0.3s ease-in-out;
}

button.rotate i.fa-chevron-up {
  transform: rotate(180deg);
}
.card__title {
  font-weight: bold;
  margin: 1rem 0;
}

.rotate {
  transform: rotate(180deg);
}
.icon__action {
  color: #27846d;
}
.container__btnExpand {
  display: flex;
  justify-content: center;
  padding: 1rem 0;
  width: 100%;
}

.icon-background {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 13.5px;
}

.adjuntChip {
  border: 2px solid #f1f1f1 !important;
}

.container__userCustomer {
  margin-top: 1rem;
}

.card__element_suscriptores div {
  padding: 0;
}

.disflex {
  display: flex;
  align-items: center;
}

.icon__interesado {
  font-size: 2rem;
}

.container__span__interesados {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.title__details--tic {
  padding: 0;
  margin: 1rem  !important;
  margin-left: 0px !important;
}

.pr-05 {
  padding-right: 0.5rem;
}

span.v-chip__content {
  text-transform: lowercase !important;
}

span.v-chip__content:first-letter {
  text-transform: uppercase !important;
}

.mobile-class {
  display: block;
}

.wrapper__iconTitle, .container__seguirTicket {
  display: flex;
  align-items: center;
  }

.iconTitle {
  font-size: 2.5rem;
  margin-right: 0.5rem;
}

.iconTitleDeatails {
  font-size: 2rem;
  margin-left: 0.5rem;
  cursor: pointer;
}
.btn-action {
  background-color: #27846d !important;
}
.btn-action .icon-ayudadigital-ojocerrado::before,
.btn-action .icon-ayudadigital-ojo::before {
  color: #ffffff !important;
  font-size: 2.5rem;
}

.mdi-share-variant {
  color: #27846d !important;
}

.btn-action .mdi-share-variant {
  background-color: #27846d !important;
}

.mdi-share-variantNegative {
  font-size: 2rem !important;
  color: #ffffff !important;
}

.customPaddingFiles {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
}

@media (max-width: 600px) {
  .wrapper__workflow {
    flex-direction: column;
  }
  .icon__workflow {
    transform: rotate(90deg);
    margin-top: 0.5rem;
  }
  .spacer.middle-hr{
    display: none !important;
  }
  .container__chip__tic {
    width: 100%;
    margin-bottom: 1rem;
  }
}

@media (max-width: 960px) {
  .title__details--tic {
    flex-direction: column !important;
  }
  #ticket-detail-view {
    .icon-ayudadigital-escalar::before  {
      color:#27846d !important;
    }
    .icon-ayudadigital-accion-interesados::before  {
      color:#27846d !important;
      font-size: inherit;
    }
  }
}

</style>
